import React, { useEffect, useState } from "react";
import {
  ReloadOutlined,
  LoadingOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import { FetchPost } from "../Common";
import loadingImg from "./../assets/img/loading.png";
import defaultAvatar from "./../assets/img/default_avatar.png";
import checkedImg from "./../assets/img/checked.png";
import loadingBlack from "./../assets/img/loading_black.png";
const STATUS = {
  //   WAIT_SCAN("等待扫描"),
  //   WAIT_CONFIRM("等待确认"),
  //   EXPIRED("已过期"),
  //   SUCCESS("验证成功"),
  //   WAIT_REDIRECT("等待跳转"),
  //   /** 非缓存记录字段，这个字段仅仅用来返回给前端 */
  //   HAS_SCANNED("已经被扫描"),
  //   REDIRECT("跳转");
  WAIT_SCAN: "WAIT_SCAN",
  WAIT_CONFIRM: "WAIT_CONFIRM", // 扫描完成后  等待手机端确认
  EXPIRED: "EXPIRED", // 二维码已过期
  SUCCESS: "SUCCESS", // 验证成功
  WAIT_REDIRECT: "WAIT_REDIRECT", // 确认登录，等待跳转
  REDIRECT: "REDIRECT", // 跳转
  HAS_SCANNED: "HAS_SCANNED", // 
  REDIRECT: "REDIRECT",
  FETCHING: "FETCHING",// 加载中
  CANCEL: "CANCEL",
};
const maskStyle = {
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  background: "rgba(0,0,0,0.7)",
};
const centerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
};

// generalGetQrCode
// {
//  "returnUrl":""
// }
// {
//  "appName":""
//     "frontType":""
//     "qrCodeUrl":""
//     "pollingUrl":""
//     "waitScanExpire":""
//     "waitConfirmExpire":""
// }
let scanTimer = -1;
let pollingTimer = -1;
let waitConfirmTimer = -1;
function UserHead(name, avatar) {
  const imgA = (
    <div>
      <img style={{ width: 66, borderRadius: 33 }} src={avatar} />
      <img
        src={checkedImg}
        style={{
          width: 24,
          display: "block",
          position: "absolute",
          top: 104,
          left: 104,
        }}
      />
    </div>
  );
  const strA = (
    <div>
      <p style={{ margin: 0 }} className="avatar-first-chr">
        {name ? name.slice(0, 1) : ""}
      </p>
      <img
        src={checkedImg}
        style={{
          width: 24,
          display: "block",
          position: "absolute",
          top: 104,
          left: 104,
        }}
      />
    </div>
  );
  return avatar ? imgA : strA;
}
export default function ScanLoginFrame(props) {
  const [qrcodeStatus, setQrcodeStatus] = useState(STATUS.WAIT_SCAN);
  const [avatar, setAvatar] = useState("");
  const [realName, setRealName] = useState("");
  const [qrcode, setQrcode] = useState({});
  // 是否扫码
  function startScanTimeout(time) {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(() => {
      clearTimeout(waitConfirmTimer);
      clearInterval(pollingTimer);
      setQrcodeStatus(STATUS.EXPIRED);
    }, time);
  }
  // 扫码后是否点击确认
  function startWaitConfirmTimeout(time) {
    clearTimeout(waitConfirmTimer);
    waitConfirmTimer = setTimeout(() => {
      setQrcodeStatus(STATUS.EXPIRED);
    }, time);
  }
  // 1秒请求一次
  function startPollingTimer(qrcode) {
    clearInterval(pollingTimer);
    pollingTimer = setInterval(() => {
      pollingQrcode(qrcode);
    }, 1000);
  }

  // 获取二维码
  let searchParams = new URL(window.location.href).searchParams;
  let paramClientId = searchParams.get("clientId");
  let paramReturnUrl = searchParams.get("ReturnUrl");
  let returnUrl =
    encodeURIComponent(paramReturnUrl) + `&clientId=${paramClientId}`;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  function getQrcode() {
    setQrcodeStatus(STATUS.FETCHING); // 正在请求状态
    FetchPost(
      `${window.PROPS.path.generalGetQrCode}?ReturnUrl=${returnUrl}`,
      {},
      (data) => {
        if (data.errorCode === "0") {
          let content = data.content || {};
          setQrcode(content);
          console.log("content", content);
          setQrcodeStatus(STATUS.WAIT_SCAN); // 等待扫码
          console.log(qrcodeStatus,140)
          // 扫描超时计时
          startScanTimeout(1000 * content.waitScanExpire);
          // 开始轮训登录状态
          startPollingTimer(content);
        } else {
          setQrcodeStatus(STATUS.EXPIRED);
        }
      }
    );
  }
  // 刷新二维码状态---是否扫码
  function pollingQrcode(qrcode) {
    FetchPost(`${qrcode.pollingUrl}?clientId=${paramClientId}`, {}, (data) => {
      if (data.errorCode === "0") {
        let content = data.content || {};
        setQrcodeStatus(content.qrStatus);
        if (content.qrStatus === STATUS.WAIT_CONFIRM) {
          // 完成扫码后 需在手机端点击确认登陆，等待超时计时
          setRealName(content.realName);
          setAvatar(content.avatar);
          startWaitConfirmTimeout(1000 * qrcode.waitConfirmExpire);
        } else if (
          content.qrStatus === STATUS.REDIRECT ||
          content.qrStatus === STATUS.EXPIRED
        ) {
          // 超时后 或者 确认登陆后 需停掉timer
          clearInterval(pollingTimer);
          clearTimeout(waitConfirmTimer);
          if (content.qrStatus === STATUS.REDIRECT) {
            setTimeout(() => {
              props.verifySuccessCallback({
                content: {
                  ...content,
                  teamUserInfoList: [
                    {
                      teamId: content.teamId,
                      appId: content.appId,
                    },
                  ],
                },
              });
            }, 1000);
          }
        } else if (content.qrStatus === STATUS.CANCEL) {
          // 手机端点击取消登陆
          // 超时后 或者 确认登陆后 需停掉timer
          clearInterval(pollingTimer);
          clearTimeout(waitConfirmTimer);
          getQrcode();
        }
      }
    });
  }
  useEffect(() => {
    getQrcode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function generalListenQrStatus() {
    //   /** 缓存记录字段 */
    //   WAIT_SCAN("等待扫描"),
    //   WAIT_CONFIRM("等待确认"),
    //   EXPIRED("已过期"),
    //   SUCCESS("验证成功"),
    //   WAIT_REDIRECT("等待跳转"),
    //   /** 非缓存记录字段，这个字段仅仅用来返回给前端 */
    //   HAS_SCANNED("已经被扫描"),
    //   REDIRECT("跳转");
  }
  return (
    <div
      style={{
        width: 460,
      }}
    >
      <h1
        style={{
          lineHeight: 1,
          color: "#232930",
          fontSize: 35,
          marginBottom: 70,
          textAlign: "center"
        }}
      >
        北京市综合办公平台2.0
      </h1>
      <div
        style={{
          border: "1px solid #F0F3F3",
          textAlign: "center",
          boxSizing: "border-box",
          padding: "70px 0 70px 0",
          borderRadius: 6,
        }}
      >
        {qrcodeStatus === STATUS.WAIT_SCAN ||
        qrcodeStatus === STATUS.FETCHING ||
        qrcodeStatus === STATUS.EXPIRED ? (
          <>
            <h1
              style={{
                lineHeight: 1,
                color: "#232930",
                fontSize: 24,
                marginBottom: 12,
              }}
            >
              扫码登录
            </h1>
            <p
              style={{
                lineHeight: 1,
                color: "#6E6F71",
                fontSize: 14,
                marginBottom: 74,
              }}
            >
              请使用手机APP“京办”扫描二维码
            </p>
          </>
        ) : null}

        <div
          style={{
            position: "relative",
            width: 184,
            height: 184,
            margin: "0 auto",
          }}
        >
          <img width="184" height="184" src={qrcode.qrCodeUrl} />
          {/* 过期 */}
          {qrcodeStatus === STATUS.EXPIRED ? (
            <div style={{ ...maskStyle, ...centerStyle }} onClick={getQrcode}>
              {/* <img style={{width: 20}} className="xuanzhun" src={`${window.PROPS.imagePath}/loading.png`} alt = 'ad_bottom' /> */}
              <ReloadOutlined style={{ color: "#fff", fontSize: 20 }} />
              <p style={{ fontSize: 14, color: "#fff", margin: "10px 0 0 0" }}>
                刷新二维码
              </p>
            </div>
          ) : null}
          {/* 待确认 */}
          {qrcodeStatus === STATUS.WAIT_CONFIRM ||
          qrcodeStatus === STATUS.REDIRECT ? (
            <div
              style={{
                ...maskStyle,
                ...centerStyle,
                background: "rgba(0,0,0,0.6)",
              }}
            >
              {UserHead(realName, avatar)}
            </div>
          ) : null}
          {/* 正在加载 */}
          {qrcodeStatus === STATUS.FETCHING  ? (
            <div style={{ ...maskStyle, ...centerStyle }}>
              <img
                style={{ width: 20 }}
                className="xuanzhuan"
                src={loadingImg}
              />

              <p style={{ fontSize: 14, color: "#fff", margin: "10px 0 0 0" }}>
                加载中...
              </p>
            </div>
          ) : null}
        </div>
        {qrcodeStatus === STATUS.WAIT_CONFIRM ||
        qrcodeStatus === STATUS.REDIRECT ||
        qrcodeStatus === STATUS.WAIT_REDIRECT ? (
          <>
            <h1
              style={{
                lineHeight: 1,
                color: "#232930",
                fontSize: 24,
                marginTop: 32,
                marginBottom: 12,
              }}
            >
              扫码成功
            </h1>
            <p
              style={{
                lineHeight: 1,
                color: "#6E6F71",
                fontSize: 12,
              }}
            >
              {qrcodeStatus === STATUS.REDIRECT ||
              qrcodeStatus === STATUS.WAIT_REDIRECT ? (
                <>
                  正在登录{" "}
                  <img width="12" className="xuanzhuan" src={loadingBlack} />
                </>
              ) : (
                "请在移动端确认登录"
              )}
            </p>
          </>
        ) : null}
      </div>
    </div>
  );
}
